import React__default, { createContext } from 'react';
import { useRenderForcingRef } from '../../hooks/useRenderForcingRef.js';
import CheckboxOrRadioGroupCaption from '../CheckboxOrRadioGroup/CheckboxOrRadioGroupCaption.js';
import CheckboxOrRadioGroupLabel from '../CheckboxOrRadioGroup/CheckboxOrRadioGroupLabel.js';
import CheckboxOrRadioGroupValidation from '../CheckboxOrRadioGroup/CheckboxOrRadioGroupValidation.js';
import CheckboxOrRadioGroup from '../CheckboxOrRadioGroup/CheckboxOrRadioGroup.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const RadioGroupContext = /*#__PURE__*/createContext(null);

/**
 *
 * Radio groups allow users to select a single item from a list of mutually exclusive options. A radio group consists of a set of radio buttons, and a label. Each radio button includes a label and a visual selection indicator.
 *
 */
const RadioGroup = ({
  children,
  disabled,
  onChange,
  name,
  direction,
  ...props
}) => {
  const [selectedRadioValue, setSelectedRadioValue] = useRenderForcingRef(null);
  const updateSelectedCheckboxes = e => {
    const {
      value,
      checked
    } = e.currentTarget;
    if (checked) {
      setSelectedRadioValue(value);
    }
  };
  return /*#__PURE__*/React__default.createElement(RadioGroupContext.Provider, {
    value: {
      disabled,
      onChange: e => {
        if (onChange) {
          updateSelectedCheckboxes(e);
          onChange(selectedRadioValue.current, e);
        }
      },
      name
    }
  }, /*#__PURE__*/React__default.createElement(CheckboxOrRadioGroup, _extends({
    disabled: disabled,
    direction: direction
  }, props), children));
};
RadioGroup.displayName = "RadioGroup";
RadioGroup.displayName = 'RadioGroup';
var RadioGroup$1 = Object.assign(RadioGroup, {
  Caption: CheckboxOrRadioGroupCaption,
  Label: CheckboxOrRadioGroupLabel,
  Validation: CheckboxOrRadioGroupValidation
});

export { RadioGroupContext, RadioGroup$1 as default };
